export const ROOT_FOLDER = "root";
export const PB_PAGE_TYPE = "PbPage";
